import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import type { createProjectSchema } from "backend/src/schemas/projectSchema";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { Project } from "../query/useProjectQuery";

import { invalidateProjectRelatedQueries } from "@/utils/cacheInvalidation";

type ProjectApiResponse = ResponseType<Project>;

function useProjectMutation() {
  const queryClient = useQueryClient();

  const mutation = useMutation<
    AxiosResponseAndError<ProjectApiResponse>["response"],
    AxiosResponseAndError<ProjectApiResponse>["error"],
    z.infer<typeof createProjectSchema>
  >({
    mutationFn: (data) =>
      ApiRequest.post<ProjectApiResponse>(requestURLs.project, data),
    onSuccess: async (res) => {
      const createdId = res.data?.data?.projectId;
      await invalidateProjectRelatedQueries(queryClient, { projectId: createdId });
    },
  });

  return mutation;
}
export default useProjectMutation;